import React, {createContext, useContext} from 'react'
import {BrowserRouter as ReactRouter, Switch, Route, withRouter} from 'react-router-dom'

const routerContext = createContext()

const Router = ({children}) => (
    <ReactRouter>
        <RouterProvider>
            {children}
        </RouterProvider>
    </ReactRouter>
)

const RouterProvider = withRouter(({children, ...routerProps}) => (
    <routerContext.Provider value={routerProps}>
        {children}
    </routerContext.Provider>
))

export const useRouter = () => {
    const routerProps = useContext(routerContext);

    if(!routerProps){
        throw new Error("Cannot use router outside Router component");
    }

    return {
        push: routerProps.history.push,
        state: routerProps.location.state 
    }
}


export const RenderRoutes = ({routes}) => (
    <Router>
        <Switch>
            {
                routes.map((route, i) => (
                    <Route key={i} path={route.path} exact={route.exact} component={route.component} />
                ))
            }
        </Switch>
    </Router>
)